import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { getTwoLetterCountryCode } from "@faire/web--source/common/consts/THREE_TO_TWO_LETTER_COUNTRY_ISO_CODE";
import { getTwoLetterLanguageCode } from "@faire/web--source/common/consts/THREE_TO_TWO_LETTER_LANGUAGE_CODE";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { getPrimaryCountriesIsoToCountryName } from "../consts/PRIMARY_COUNTRIES_ISO_TO_COUNTRY_NAME";
import { getFullLanguageName } from "../consts/THREE_TO_FULL_LANGUAGE_NAME";
import { isNotUndefined } from "../typescriptUtils";
var THREE_LETTER_PRIMARY_COUNTRY_CODES = function(strictLocalize) {
    var _obj;
    return _object_spread_props(_object_spread({}, getPrimaryCountriesIsoToCountryName(strictLocalize)), (_obj = {}, _define_property(_obj, ISO3166Alpha3.DEU, "Deutschland"), _define_property(_obj, ISO3166Alpha3.ITA, "Italia"), _define_property(_obj, ISO3166Alpha3.ESP, "España"), _define_property(_obj, ISO3166Alpha3.PRT, "Portugal"), _define_property(_obj, ISO3166Alpha3.USA, "United States"), _obj));
};
var _obj;
var defaultCountryLanguage = (_obj = {}, _define_property(_obj, Language.DEU, ISO3166Alpha3.DEU), _define_property(_obj, Language.ITA, ISO3166Alpha3.ITA), _define_property(_obj, Language.SPA, ISO3166Alpha3.ESP), _define_property(_obj, Language.POR, ISO3166Alpha3.PRT), _define_property(_obj, Language.ENG, ISO3166Alpha3.USA), _define_property(_obj, Language.FRA, ISO3166Alpha3.FRA), _define_property(_obj, Language.NLD, ISO3166Alpha3.NLD), _define_property(_obj, Language.SWE, ISO3166Alpha3.SWE), _define_property(_obj, Language.DAN, ISO3166Alpha3.DNK), _obj);
export var convertLocaleToCountryLocaleString = function(localeKey) {
    var _getTwoLetterLanguageCode;
    var language = localeKey.language, countryCode = localeKey.country;
    if (!language) {
        return undefined;
    }
    // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
    if (countryCode && defaultCountryLanguage[language] !== countryCode) {
        var _getTwoLetterLanguageCode1, _getTwoLetterCountryCode;
        return ((_getTwoLetterLanguageCode1 = getTwoLetterLanguageCode(language)) === null || _getTwoLetterLanguageCode1 === void 0 ? void 0 : _getTwoLetterLanguageCode1.toLowerCase()) + "-" + ((_getTwoLetterCountryCode = getTwoLetterCountryCode(countryCode)) === null || _getTwoLetterCountryCode === void 0 ? void 0 : _getTwoLetterCountryCode.toLowerCase());
    }
    return (_getTwoLetterLanguageCode = getTwoLetterLanguageCode(language)) === null || _getTwoLetterLanguageCode === void 0 ? void 0 : _getTwoLetterLanguageCode.toLowerCase();
};
export var languageAndCountryText = function(language, strictLocalize, countryCode) {
    return "".// @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
    concat(getFullLanguageName(language), " (").concat(THREE_LETTER_PRIMARY_COUNTRY_CODES(strictLocalize)[countryCode !== null && countryCode !== void 0 ? countryCode : ISO3166Alpha3.USA], ")");
};
export var languageWithCountryOptions = function(availableLocale, strictLocalize) {
    return availableLocale.map(function(localeKey) {
        var language = localeKey.language, countryCode = localeKey.country;
        if (language === undefined) {
            return undefined;
        }
        var convertedLocale = convertLocaleToCountryLocaleString(localeKey);
        if (convertedLocale === undefined) {
            return undefined;
        }
        return {
            label: languageAndCountryText(language, strictLocalize, countryCode),
            value: convertedLocale
        };
    }).filter(isNotUndefined);
};
